<template>
  <div class="note section" id="note" @click="showSubInfo.value = false">
    <div class="layout-content">
      <SubTitle :text="title" :subText="subText" />
      <div class="l-content">
        <div class="block" v-for="(item, idx) in data" :key="idx">

          <div class="title">
            <div class="word">
              <img class="word-img" :src="item.logo" alt="">

              <div
                class="word"
                :class="{
                  'is-origin': item.type === 'ai',
                  'is-purple': item.type === 'blockchain',
                  'is-blue': item.type === 'product'
                }"
              >
                <p class="word-title">{{ item.title }}</p>
                <p class="intro-title ">{{item.introTitle}}</p>
              </div>
            </div>
          </div>

          <div class="intro" v-html="item.intro" />

          <div class="block-btn">
            <div class="block-btn-default" v-if="item.moreBtn.detailsText" @click="playText(item.moreBtn.detailsText)">
              {{item.moreBtn.details}}
            </div>
            <a class="block-btn-link" :href="item.moreBtn.understandMoreLink" target="_blank">
              <div class="block-btn-default">
                {{item.moreBtn.understandMore}}
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubTitle from '@/components/SubTitle'

import * as GlobalLayer from '@/utils/globalLayer'
import { mapState } from 'vuex'

export default {
  data: () => ({
    showSubInfo: {
      type: 'ai',
      value: false
    },
    qItemWidth: 486
  }),

  components: {
    SubTitle
  },

  props: ['data'],

  computed: {
    ...mapState([
      'isMobile',
      'isEnLang'
    ]),
    title () {
      return this.isEnLang ? 'SUBJECTS' : '赛题说明'
    },
    subText () {
      return this.isEnLang ? 'FINTECHATHON' : 'SUBJECTS'
    }
  },

  methods: {
    playText (detailsText) {
      GlobalLayer.createModal(this.$store, {
        detailsText,
        isShowBtn: true
      })
    }
  }
}
</script>

<style lang="scss" scoped>

img {
  width: 100%; height: 100%;
}

.note {
  background: #F5F7F9;
  padding-bottom: 120px;

  @include mobile {
    padding-bottom: 30px;
  }
}

.l-content {
  display: flex; justify-content: space-between;
  position: relative;

  @include mobile {
    display: flex; flex-wrap: wrap;
    margin-top: 6px;
  }
}

.block {
  width: 384px; height: 497px;
  padding: 44px 42px;
  background: #FFFFFF;

  @include mobile {
    width: 100%; height: 100%;
    padding: 32px 32px 30px;
    margin-bottom: 20px;
  }
}

.title {
  display: flex; align-items: center;
}

.word {
  display: flex; flex-direction: column;
}

.word-img {
  width: 62px; height: 62px;
  margin-bottom: 17px;

  @include mobile {
    width: 48px; height: 48px;
  }
}

.word {
  &.is-purple {
    color: #7550E1;
  }

  &.is-blue {
    color: #376EFD;
  }

  &.is-origin {
    color: #E1574D;
  }
}

.word-title {
  margin-bottom: 32px;
  font-size: 16px; font-weight: 600;
  line-height: 35px;

  @include mobile {
    margin-bottom: 24px;
    font-size: 13px; font-weight: 600;
    line-height: 18px;
  }
}

.intro-title {
  font-size: 28px; font-weight: 600;
  line-height: 40px;

  @include mobile {
    font-size: 22px; font-weight: 600;
    line-height: 30px;
  }
}

.btn {
  width: 100px;
  color: $black;
  font-size: 16px;
  text-align: center;
  opacity: 0.5;
  border: 1px solid #828991;
}

.wrapper {
  position: absolute; top: 100%; right: -2px; z-index: 100;
  width: 250px;
}

.word-text-icon {
  display: inline-block;
  width: 16px; height: 16px;
  margin: 0 5px;
  vertical-align: middle;
  background: url('https://static001.geekbang.org/resource/image/c0/df/c07e016074c5102d9e41d8yy84203fdf.png') center / cover no-repeat;
}

.word-text {
  color: #303030;
  line-height: 20px;
  font-size: 14px; font-weight: 400;
}

.intro {
  height: 156px;
  margin: 16px 0 16px;
  color: #000000;
  line-height: 30px;
  font-size: 15px; font-weight: 400;
  opacity: 0.5;

  @include mobile {
    height: auto;
    margin: 14px 0 20px;
    font-size: 14px; font-weight: 400;
    color: #000000;
    line-height: 26px;
  }
}

.block-btn {
  display: flex;
}

.block-btn-link {
  &:hover .block-btn-text {
    color: #000000;
    opacity: 0.7;
  }
}

.block-btn-default {
  width: 116px; height: 40px;
  margin-right: 20px;
  text-align: center;
  font-size: 15px; font-weight: 500;
  border: 1px solid #000000;
  line-height: 40px;
  color: #000000;
  opacity: 0.9;
  cursor: pointer;

  @include mobile {
    width: 98px; height: 34px;
    line-height: 34px;
  }

  &:hover {
    background: #000000;
    color: #FFFFFF;
    opacity: 0.9;

    @include mobile {
      background: none;
      color: #000000;
      opacity: 1;
    }
  }
}

</style>
